import React from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { CustomerList } from '../../components/customers/CustomerList';

const CustomersPage: React.FC = () => {
  return (
    <Box sx={{ width: '100%' }}>
      <Paper elevation={1} sx={{ p: 2, mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          Geçici Müşteri Kayıt Linki
        </Typography>
        <Button
          component={RouterLink}
          to="/customer-registration"
          variant="contained"
          color="primary"
        >
          Kayıt Formuna Git
        </Button>
      </Paper>
      <CustomerList />
    </Box>
  );
};

export default CustomersPage;